import { useField } from '@oneform/react';
export const useMintedField = ({ inputValue, isCheckboxElement = false, isMultipleElement = false, name, onChange = () => { }, onVisit = () => { }, }) => {
    const { errorMessages, fieldName, isChecked, isVisited, updateFieldValue, value, visitField, } = useField({
        inputValue,
        isCheckboxElement,
        isMultipleElement,
        name,
        // @ts-ignore 2322
        onChange,
        // @ts-ignore 2322
        onVisit,
    });
    return ({
        checked: isChecked,
        error: (typeof errorMessages[0] === 'string'
            ? errorMessages[0]
            : (errorMessages[0]
                ? ' '
                : '')),
        name: fieldName,
        onBlur: visitField,
        onChange: updateFieldValue,
        touched: isVisited,
        value,
    });
};
